// Extract a Google Drive folder ID from either a raw ID or a full URL.
export function extractDriveFolderId(input) {
  if (!input) return "";
  let s = String(input).trim();
  try { s = decodeURIComponent(s); } catch {}
  try {
    const u = new URL(s);
    const qId = u.searchParams.get("id");
    if (qId) s = qId;
    else {
      const m = u.pathname.match(/\/folders\/([a-zA-Z0-9_-]+)/);
      if (m) s = m[1];
    }
  } catch {}
  s = s.split("?")[0];
  const ok = /^[A-Za-z0-9_-]{10,}$/.test(s);
  return ok ? s : "";
}

// NEW: Extract a Google Drive FILE id from a full URL or raw id
export function extractDriveFileId(input) {
  if (!input) return "";
  let s = String(input).trim();
  try { s = decodeURIComponent(s); } catch {}
  // If it's a URL, try different patterns
  try {
    const u = new URL(s);
    // public share often has ?id=<ID>
    const qId = u.searchParams.get("id");
    if (qId) s = qId;
    else {
      // /file/d/<ID>/view
      let m = u.pathname.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
      if (m) s = m[1];
      else {
        // open?id=<ID> (already checked), or uc?id=<ID>, etc.
        m = u.search.match(/[?&]id=([a-zA-Z0-9_-]+)/);
        if (m) s = m[1];
      }
    }
  } catch {}
  s = s.split("?")[0];
  const ok = /^[A-Za-z0-9_-]{10,}$/.test(s);
  return ok ? s : "";
}

// Build a big-ish thumbnail URL
export function driveThumbUrl(fileId, size = 1200) {
  return `https://drive.google.com/thumbnail?id=${encodeURIComponent(fileId)}&sz=w${size}`;
}

// Build a full-view URL suitable for <img> src
export function driveViewUrl(fileId) {
  return `https://drive.google.com/uc?export=view&id=${encodeURIComponent(fileId)}`;
}
